/* eslint-disable */
export default {
  contactDetails: '連絡人詳情',
  loadingContact: '正在載入連絡人 ...',
  contactNotFound: '找不到連絡人。',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
